import React from 'react';
import GoogleCalendarIntegration from './GoogleCalendarIntegration';
import { Helmet } from 'react-helmet';

const Integrations = () => {
  return (
    <div className="integrations-container flex-container">
      <Helmet>
        <title>Integrations - DeTalks</title>
      </Helmet>
      <GoogleCalendarIntegration />
      <style jsx>{`
        .integrations-container {
          max-width: 1000px;
          padding: 20px;
        }
      `}</style>
    </div>
  );
};

export default Integrations;
